import $ from 'jquery'

const INSERTION_TIMEOUT = 15000

export function fetchBinaryResponse (url) {
  return $.ajax({
    url,
    xhrFields: {
      responseType: 'blob'
    },
    timeout: INSERTION_TIMEOUT
  })
}

export function fetchTextResponse (url) {
  return $.ajax({
    url,
    dataType: 'text',
    timeout: INSERTION_TIMEOUT
  })
}
